import { useContext, useMemo } from 'react'
import moment from 'moment'
import GeoContext from 'contexts/geoContext'
import config from 'constants/config'
import EasterTakeover from 'constants/siteTakeover/easterTakeover'
import LunarNewYearTakeover from 'constants/siteTakeover/lunarNewYearTakeover'
import MarchTravelFrenzyTakeover from 'constants/siteTakeover/marchTravelFrenzyTakeover'
import TourBestAsiaPromoTakeover from 'constants/siteTakeover/tourBestAsiaPromoTakeover'
import ValentineTakeover from 'constants/siteTakeover/valentineTakeover'
import SocietyTriplePointsTakeover from 'constants/siteTakeover/societyTriplePointsTakeover'
import { NeverEndingSummerTakeover } from 'constants/siteTakeover/neverEndingSummerTakeover'

const takeovers = [
  LunarNewYearTakeover,
  ValentineTakeover,
  MarchTravelFrenzyTakeover,
  TourBestAsiaPromoTakeover,
  EasterTakeover,
  SocietyTriplePointsTakeover,
  NeverEndingSummerTakeover,
]

interface TakeoverOptions {
  /**
   * Check which takeover applies to the vertical given
   */
  vertical?: App.SiteTakeoverVertical;
  /**
   * Check which takeover applies to the offer given
   */
  offer?: App.Offer | App.HotelOffer | App.HotelOfferSummary | App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary | App.CruiseOffer | App.VillaOffer | App.VillaOfferSummary | App.TourOffer | App.TourOfferSummary;
  /**
   * Check which takeover applies for specifically the hero carousel condition
   */
  heroVertical?: App.SiteTakeoverHeroVertical;
}

function useCurrentSiteTakeover(options: TakeoverOptions = {}): App.SiteTakeover | undefined {
  const { currentRegionCode } = useContext(GeoContext)
  const { vertical, offer, heroVertical } = options
  const currentTakeover = useMemo(() => {
    const now = moment()
    return takeovers.find(takeover => {
      let active = false
      if (typeof window !== 'undefined' && !!window.__DEBUG_TAKEOVER_ID__) {
        active = takeover.id.toLowerCase() === window.__DEBUG_TAKEOVER_ID__.toLowerCase()
      } else {
        // first we see if the takeover is active by ensuring this is the right brand/region code and date
        active = takeover.brands.has(config.BRAND) &&
          takeover.regions.has(currentRegionCode) &&
          now.isBetween(takeover.startDate, takeover.endDate)
      }

      // Next, if any options are povided - we ensure the they match the takeover
      // Is the take over for this particlar vertical?
      const applicable = (vertical ? takeover.verticals.has(vertical) : true) &&
      // Is the take over for this particlar hero vertical? Fallback to our upper level vertical if not specified
        (heroVertical ? takeover.heroCarousel.verticals?.includes(heroVertical) : true) &&
      // Is the take over for this particlar offer type?
        (offer && takeover.offerTypes ? takeover.offerTypes.has(offer.type) : true) &&
      // Is the take over for this particlar campaign tag?
        (offer && takeover.campaignTags ? offer.campaignTags.some(tag => takeover.campaignTags!.has(tag)) : true)

      return active && applicable
    })
  }, [currentRegionCode, vertical, offer, heroVertical])

  return currentTakeover
}

export default useCurrentSiteTakeover
